import React, { Component } from 'react';
import './NotificationViewer.css';
import bellSvg from './bell.svg';
import PropTypes from 'prop-types';
import Popover from 'react-awesome-popover';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';

class NotificationViewer extends Component {
  static propTypes = {
    recentActivity: PropTypes.bool,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        message: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
        unread: PropTypes.bool.isRequired,
        user: PropTypes.string,
        content: PropTypes.string,
      })
    ),
    showLoader: PropTypes.bool,
    total: PropTypes.number,
    totalUnread: PropTypes.number,
    onMarkAllAsRead: PropTypes.func,
    onMessageOpen: PropTypes.func,
    onMessageRead: PropTypes.func,
    onMessageUnread: PropTypes.func,
    onShowNewer: PropTypes.func,
    onShowOlder: PropTypes.func,
    onPageChange: PropTypes.func,
  };

  static defaultProps = {
    recentActivity: false,
    currentPage: 1,
    pageSize: 25,
    messages: [],
    showLoader: false,
    total: 0,
    totalUnread: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      showRead: false,
      open: false,
    };
  }

  scrollToTop = () => {
    if (this.recentActContentEl) {
      this.recentActContentEl.scrollTop = 0;
    }
  };

  render() {
    const { recentActivity, currentPage, pageSize, total } = this.props;
    return recentActivity ? (
      <div
        className="recent-activity-content"
        ref={(el) => (this.recentActContentEl = el)}
      >
        <SimpleTable
          className="projects-table"
          headers={['', '']}
          rows={this.renderRecentActivityMessages()}
          emptyMessage="No Activity"
          onRowSelected={this.handleMessageOpen}
        />
        <div className="pagination-container">
          <SimplePagination
            currentPage={currentPage}
            pageSize={pageSize}
            total={total}
            onPageChange={this.handlePageChange}
          />
        </div>
      </div>
    ) : (
      <div className="notification-viewer">
        <Popover
          placement="bottom-end"
          open={this.state.open}
          onClose={this.handleOnClose}
          onOpen={this.handleOnOpen}
        >
          <img className="nv-bell-image" src={bellSvg} alt="bell" />
          {this.renderNotificationsContainer()}
        </Popover>

        {this.props.totalUnread > 0 && (
          <div
            className={
              'nv-unread-indicator ' +
              (this.props.totalUnread > 99 ? 'medium' : 'small')
            }
          >
            {this.props.totalUnread}
          </div>
        )}
      </div>
    );
  }

  renderNotificationsContainer() {
    const maxPages = Math.ceil(this.props.total / this.props.pageSize);

    if (this.props.total === 0) {
      return <div className="nv-no-notifications">No Notifications</div>;
    } else {
      return (
        <div className="nv-notification-container">
          {(this.props.total > this.props.pageSize ||
            this.props.showLoader ||
            this.props.totalUnread > 0) && (
            <div className="nv-messages-buttons-container">
              {this.props.total > this.props.pageSize && (
                <div className="nv-messages-buttons">
                  <button
                    disabled={this.props.currentPage === 1}
                    onClick={this.handleNewer}
                  >
                    &lt;
                  </button>
                  <div>{`${
                    (this.props.currentPage - 1) * this.props.pageSize + 1
                  }-${Math.min(
                    this.props.currentPage * this.props.pageSize,
                    this.props.total
                  )} of ${this.props.total}`}</div>
                  <button
                    disabled={this.props.currentPage === maxPages}
                    onClick={this.handleOlder}
                  >
                    &gt;
                  </button>
                </div>
              )}

              {this.props.showLoader && (
                <div className="nv-loader-container">Loading...</div>
              )}

              {this.props.totalUnread > 0 && (
                <div className="nv-messages-buttons">
                  <button onClick={this.handleMarkAllAsRead}>
                    Mark all as read
                  </button>
                </div>
              )}
            </div>
          )}

          {this.renderMessages(this.props.messages)}
        </div>
      );
    }
  }

  renderMessages(messages) {
    return (
      <div className="nv-messages">
        <ul>
          {messages.map((element) => {
            if (element.user !== null && element.user !== undefined) {
              return (
                <li key={element.id}>
                  <div className={element.unread ? 'unread' : 'read'}>
                    <span className="user">{element.user}</span>{' '}
                    <span>{element.message}</span>{' '}
                    <span className="target">{element.target}</span>
                    {element.content && (
                      <div>
                        <span>{element.content}</span>
                      </div>
                    )}
                  </div>
                  {this.renderMessagePopover(
                    element.unread,
                    element.id,
                    element.webAvailable
                  )}
                </li>
              );
            } else {
              return (
                <li key={element.id}>
                  <div className={element.unread ? 'unread' : 'read'}>
                    <span className="target">{element.target}</span>{' '}
                    <span>{element.message}.</span>
                    {element.content && (
                      <div>
                        <span>{element.content}</span>
                      </div>
                    )}
                  </div>
                  {this.renderMessagePopover(
                    element.unread,
                    element.id,
                    element.webAvailable
                  )}
                </li>
              );
            }
          })}
        </ul>
      </div>
    );
  }

  renderMessagePopover(unread, id, webAvailable = true) {
    return (
      <div className="nv-message-popover">
        <div className="nv-message-popover-buttons">
          {webAvailable && (
            <span onClick={this.handleMessageOpen.bind(this, id)}>Open</span>
          )}
          {unread ? (
            <span onClick={this.handleMessageRead.bind(this, id)}>
              Mark as read
            </span>
          ) : (
            <span onClick={this.handleMessageUnread.bind(this, id)}>
              Mark as unread
            </span>
          )}
        </div>
      </div>
    );
  }

  renderRecentActivityMessages() {
    const { messages } = this.props;
    return messages.map((element) => {
      if (element.user !== null && element.user !== undefined) {
        return {
          id: element.id,
          data: [
            <div className="recent-activity-message">
              <div className={element.unread ? 'unread' : 'read'}>
                <span className="user">{element.user}</span>{' '}
                <span>{element.message}</span>{' '}
                <span className="target">{element.target}</span>
                {element.content && (
                  <div>
                    <span>{element.content}</span>
                  </div>
                )}
              </div>
            </div>,
          ],
        };
      } else {
        return {
          id: element.id,
          data: [
            <div className="recent-activity-message">
              <div className={element.unread ? 'unread' : 'read'}>
                <span className="target">{element.target}</span>{' '}
                <span>{element.message}.</span>
                {element.content && (
                  <div>
                    <span>{element.content}</span>
                  </div>
                )}
              </div>
            </div>,
          ],
        };
      }
    });
  }

  handleMessageOpen = (id, event) => {
    event && event.preventDefault();
    if (this.props.onMessageOpen) {
      this.props.onMessageOpen(id);
      // Update state after calling "on" function
      this.setState({
        open: false,
      });
    }
  };

  handleMessageRead = (id, event) => {
    event.preventDefault();
    if (this.props.onMessageRead) {
      this.props.onMessageRead(id);
    }
  };

  handleMessageUnread = (id, event) => {
    event.preventDefault();
    if (this.props.onMessageUnread) {
      this.props.onMessageUnread(id);
    }
  };

  handleMarkAllAsRead = (event) => {
    event.preventDefault();
    if (this.props.onMarkAllAsRead) {
      this.props.onMarkAllAsRead();
    }
  };

  handleOnClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOnOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleNewer = (event) => {
    event.preventDefault();
    if (this.props.onShowNewer) {
      this.props.onShowNewer();
    }
  };

  handleOlder = (event) => {
    event.preventDefault();
    if (this.props.onShowOlder) {
      this.props.onShowOlder();
    }
  };

  handlePageChange = (newPage) => {
    const { onPageChange } = this.props;
    this.scrollToTop();
    onPageChange && onPageChange(newPage);
  };
}

export default NotificationViewer;



// WEBPACK FOOTER //
// ./src/components/header/NotificationViewer.js